import CounterBlocks from '@components/CounterBlocks';
import { useAppSelector } from '@hooks/useStore';
import * as React from 'react';
import { useMemo } from 'react';

const AccessForm: React.FC = () => {
    const projectUsers = useAppSelector((state) => state.projectsSlice.current.users);
    const accessRequestsListByProject = useAppSelector((state) => state.userSlice.accessRequestsListByProject);

    const usersList = useMemo(
        () =>
            projectUsers.map((user) => ({
                accessLevel: user.access_level ? 'view' : 'edit',
                email: user.user.email,
            })),
        [JSON.stringify(projectUsers)],
    );

    return (
        <div>
            <CounterBlocks.AccessUsers
                usersList={usersList}
                accessRequestsListByProject={accessRequestsListByProject}
            />
        </div>
    );
};

export default AccessForm;
